<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="modal.show"
                   :title="$t('Increment Calculation Source')"
                   @show="onShow"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   scrollable>
      <input-widget :model="model" attribute="increment_calculation_source" value-field="value"
                    display-field="${item.key}" type="select2" :items="incrementCalculationSource"/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import IncrementCalculationModel from "@/modules/sales/view/terms/modals/IncrementCalculationModel.model";

  const {mapState, mapActions} = createNamespacedHelpers('sales');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "IncrementCalculationModal",
    components: {InputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new IncrementCalculationModel(),
      }
    },
    methods: {
      ...mapActions(['showIncrementCalculationModal', 'hideIncrementCalculationModal', 'saveTermsPartialData']),
      async onSubmit() {
        let success = await this.$confirm(this.$i18n.t("Changing increment calculation source will remove all increments set on lot level. Would you like to proceed?"))
        if (!success) {
          return
        }
        this.loading = true;
        let response = await this.saveTermsPartialData({uuid: this.object.uuid, increment_calculation_source: this.model.increment_calculation_source});
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.$toast('success', this.$t('Increment calculation source successfully saved'));
          this.hideIncrementCalculationModal();
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            for (let index in response.body) {
              this.model.increment_calculation_source[index].setMultipleErrors(response.body[index]);
            }
          }
        }
      },
      onShow() {
        this.initIncrements();
      },
      onHidden() {
        this.model = new IncrementCalculationModel();
        this.hideIncrementCalculationModal();
      },
      initIncrements() {
        this.model.increment_calculation_source = this.object.increment_calculation_source;
      },
    },
    watch: {
      editObjects() {
        this.initIncrements();
      }
    },
    computed: {
      ...mapState({
        modal: state => state.view.incrementCalculationData.modal,
        object: state => state.view.incrementCalculationData.modal.object
      }),
      ...globalMapState(['incrementCalculationSource']),
    },
  }
</script>

<style lang="scss" scoped>
</style>

